export const downloadExcel = async (excelErrorFile: string, excelName: string) => {
  const link = document.createElement('a')
  link.href = `data:application/octet-stream;base64,${excelErrorFile}`
  link.download = `${excelName}.xlsx`
  link.click()
  link.remove()
}